module.exports = __webpack_public_path__ + "img/form-bg--991.9a22cda.jpg";